export const GET_QUALIFIER_CONFIG_SUCCESS = 'GET_QUALIFIER_CONFIG_SUCCESS'
export const ADD_LOG_SUCCESS = 'ADD_LOG_SUCCESS'
export const CLEAR_LOG_SUCCESS = 'CLEAR_LOG_SUCCESS'
export const SET_INTERVAL_SUCCESS = 'SET_INTERVAL_SUCCESS'
export const CLEAR_INTERVAL_SUCCESS = 'CLEAR_INTERVAL_SUCCESS'
